// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"769":"32fc2382","2714":"e2d09729","4113":"57010fd4"}[chunkId] + ".chunk.css";
};